import React from "react";
import Sticky from "wil-react-sticky";
import styled from "styled-components";

const LeftNav = ({ height }) => {
  return (
    <Left>
      <Sticky offsetTop={100}>
        <ServiceNavContent>
          <NavItem height={height}>
            <h3>Benefits</h3>
          </NavItem>
          <NavItem height={height}>
            <h3>Custom Approach</h3>
          </NavItem>
          <NavItem>
            <h3>Why Scrumanac</h3>
          </NavItem>
          <NavItem height={height}>
            <h3>Collaboration Models</h3>
          </NavItem>
        </ServiceNavContent>
      </Sticky>
    </Left>
  );
};

const Left = styled.div`
  --space: 2rem;
  width: 26%;
  position: sticky;
  margin-top: 70px;
  top: 100px;
  --offset: var(--space);
  /* ... */
  position: sticky;
  top: var(--offset);
  @media (max-width: 980px) {
    display: none;
    flex-direction: column;
  }
`;

const NavItem = styled.div`
  margin-bottom: 1.5rem;
  border-left: #f5f5f5;
  font-family: 'Archivo' Hv BT;
  font-weight: 900;
  font-size: 12px;

  text-transform: uppercase;
  color: #3d3d3d;
  position: relative;
  display: block;
  padding: 0.25rem 1rem;
  line-height: 1;
  h3 {
    font-weight: 900;
  }
`;

const ServiceNavContent = styled.div`
  transform: translate3d(0px, 0px, 0px);
`;

export default LeftNav;
